import React from 'react';

import { Box } from '@rbilabs/components-library/build/components/layout';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import ActionButton from 'components/action-button';
import Dialog from 'components/dialog';
import useMediaQuery from 'hooks/use-media-query';
import useRoutes from 'hooks/use-routes';
import { CustomEventNames } from 'state/mParticle';

interface Props {
  onDismiss: () => void;
}

const LoginRequiredDialog: React.FC<Props> = ({ onDismiss }) => {
  const { getLocalizedRouteForPath } = useRoutes();
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const isDesktop = useMediaQuery('desktop');
  return (
    <Dialog
      onDismiss={onDismiss}
      heading={
        <>
          {formatMessage(
            { id: 'mustBeLoggedInToRedeemCoupon' },
            {
              br: <br />,
            }
          )}
        </>
      }
      actions={
        <>
          <Box width="100%" minWidth="auto">
            <ActionButton onlyIcon fullWidth onClick={onDismiss}>
              {formatMessage({ id: 'cancel' })}
            </ActionButton>
          </Box>
          <Box margin={isDesktop ? '0 0 0 1rem' : '1rem 0 0'} width="100%" minWidth="auto">
            <ActionButton
              fullWidth
              onlyIcon
              eventName={CustomEventNames.BUTTON_CLICK_SIGN_UP}
              onClick={() => navigate(getLocalizedRouteForPath('signup'))}
            >
              {formatMessage({ id: 'signUp' })}
            </ActionButton>
          </Box>
        </>
      }
      modalAppearanceEventMessage="Login Required to Redeem Coupon"
    />
  );
};

export default LoginRequiredDialog;
